<div class="wrapper">
  <div class="emr-page-container">
    <div class="emr-page-title">{{ currentUser.firstName }}'s List of Patients</div>
    <div class="patient-list-header">
      <div *ngIf="isAdmin" class="btn-container">
        <button pButton pRipple type="button" label="New Patient" icon="pi pi-plus"
          [routerLink]="createPatientPath"></button>
        <!-- <button
          pButton
          pRipple
          type="button"
          label="Import CSV"
          icon="pi pi-upload"
          [disabled]="true"
          (click)="openImportPatientsDialog()"
        ></button> -->
        <button pButton pRipple type="button" label="Delete Patients" class="p-button-danger" icon="pi pi-trash"
          [disabled]="!didSelectPatients" (click)="openDeletePatientsDialog()"></button>
      </div>
      <div class="dialog-container">
        <emr-confirmation-dialog title="Delete Patients" [(display)]="showDeletePatientsDialog"
          (dialogClose)="onCloseDeletePatientsDialog($event)" [confirmDisabled]="!confirmDeletePatients">
          <p>You are about to delete the following patients:</p>
          <ul>
            <li *ngFor="let patient of selectedPatients">
              {{ patient.getNameFirstMiddleLast() }} ({{ patient.id }})
            </li>
          </ul>
          <p>This will also delete these patients for all users they are assigned to.</p>
          <p>Are you sure you would like to continue?</p>
          <p-checkbox [binary]="true" id="deleteSelectedPatientsChckBox"
            [(ngModel)]="confirmDeletePatients"></p-checkbox>
          <label class="label-right-of-box" for="deleteSelectedPatientsChckBox">I want to delete the above
            patients.</label>
        </emr-confirmation-dialog>
      </div>
    </div>

    <div class="table-container">
      <app-patient-table type="main" [patients]="patients" [(selectedPatients)]="selectedPatients"
        [loading]="isLoading"></app-patient-table>
    </div>
  </div>
</div>